import React from "react";
import { euro } from "../lib/format";

const stOf = (pct) => (pct >= 100 ? "completato" : pct > 0 ? "in_corso" : "da_iniziare");
const LABEL = { da_iniziare: "Da iniziare", in_corso: "In corso", completato: "Completato" };
const CLS = {
  da_iniziare: "bg-slate-100 text-slate-500",
  in_corso: "bg-amber-100 text-amber-700",
  completato: "bg-emerald-100 text-emerald-700",
};

export default function PublicProgress({ quote, cur, onGoTo }) {
  const prog = (Array.isArray(quote.progress) && quote.progress.length)
    ? quote.progress
    : (quote.items || []).map((it) => ({ title: it.title, percent: 0, note: "" }));
  const avg = quote.progress_overall ?? 0;
  const depRequired = quote.payment?.status !== "non_richiesto";
  const depPaid = quote.payment?.status === "pagato";
  const bal = quote.balance || {};
  const saldoPaid = bal.status === "pagato";

  return (
    <>
      {avg >= 50 && avg < 100 && depRequired && !depPaid && (
        <div data-testid="payment-banner-acconto" className="mb-4 rounded-xl border border-amber-300 bg-amber-50 px-5 py-4 flex items-center justify-between gap-3 flex-wrap">
          <p className="text-sm font-semibold text-amber-800">I lavori sono al {avg}%: è previsto il versamento dell'acconto.</p>
          <button type="button" data-testid="go-to-deposit" onClick={() => onGoTo("acconto")} className="text-sm font-semibold text-white bg-amber-600 rounded-lg px-4 py-2">Vedi importi</button>
        </div>
      )}
      {avg >= 100 && !saldoPaid && bal.amount > 0 && (
        <div data-testid="payment-banner-saldo" className="mb-4 rounded-xl border border-emerald-300 bg-emerald-50 px-5 py-4 flex items-center justify-between gap-3 flex-wrap">
          <p className="text-sm font-semibold text-emerald-800">
            Lavori completati al 100%: è previsto il saldo finale di <span data-testid="banner-saldo-amount" className="font-mono">{euro(bal.amount, cur)}</span>
            {bal.deposit_paid_amount > 0 && <span className="font-normal"> (totale {euro(bal.total, cur)} − acconto versato {euro(bal.deposit_paid_amount, cur)})</span>}.
          </p>
          <button type="button" data-testid="go-to-balance" onClick={() => onGoTo("saldo")} className="text-sm font-semibold text-white bg-emerald-600 rounded-lg px-4 py-2">Vedi importi</button>
        </div>
      )}
      <div data-testid="public-progress" className="mb-8 rounded-2xl border border-indigo-100 bg-indigo-50/40 p-5">
        <div className="flex items-center justify-between mb-3">
          <h2 className="text-lg font-bold text-slate-900">Stato di Avanzamento Lavori</h2>
          <span data-testid="public-progress-overall" className="font-mono font-bold text-primary">{avg}%</span>
        </div>
        <div className="h-3 rounded-full bg-slate-200 overflow-hidden mb-4">
          <div className="h-full bg-indigo-500 transition-all duration-500" style={{ width: `${avg}%` }} />
        </div>
        <div className="space-y-2.5">
          {prog.map((p, i) => {
            const pct = Number(p.percent) || 0;
            const st = stOf(pct);
            return (
              <div key={i} data-testid={`public-progress-item-${i}`} className="bg-card rounded-lg border border-slate-200 p-3">
                <div className="flex items-center justify-between gap-2 flex-wrap">
                  <span className="text-sm font-medium text-slate-800">{p.title || `Voce ${i + 1}`}</span>
                  <span data-testid={`public-progress-item-${i}-percent`} className={`text-xs font-semibold px-2 py-0.5 rounded-full ${CLS[st]}`}>{LABEL[st]} · {pct}%</span>
                </div>
                <div className="h-1.5 rounded-full bg-slate-100 overflow-hidden mt-2">
                  <div className={`h-full transition-all duration-500 ${st === "completato" ? "bg-emerald-500" : "bg-indigo-500"}`} style={{ width: `${pct}%` }} />
                </div>
                {p.note && <p className="text-xs text-slate-500 mt-1.5">{p.note}</p>}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}
